import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
import { QuestionName } from "./QuestionName";
import { QuestionContentAlignment, QuestionDisplayMode } from "./Questions-Types";
export const QuestionInput = (props) => {
    const { question, moduleConfig, inputElement, headerFirst = true, containerProps = {}, inputProps = {} } = props;
    const alignment = moduleConfig.AlignContent === QuestionContentAlignment.Center ? "center" : "start";
    const defaultProps = { display: "flex", flexDirection: "column", alignItems: alignment };
    const questionProps = Object.assign(Object.assign({}, defaultProps), containerProps);
    const theme = useTheme();
    const nameSpacing = theme.spacing(2);
    const nameProps = {
        question: question,
        variant: "body1",
        style: {
            marginTop: nameSpacing,
            marginBottom: nameSpacing,
            textAlign: alignment,
        },
    };
    // for text fields & dropdowns, the name is rendered in the input itself
    const renderName = question.DisplayMode !== QuestionDisplayMode.TextInput &&
        question.DisplayMode !== QuestionDisplayMode.NumberInput &&
        question.DisplayMode !== QuestionDisplayMode.Dropdown;
    // the slider doesnt like being in a container
    const withContainer = !(question.DisplayMode === QuestionDisplayMode.Buttons && !moduleConfig.IsGridLayout);
    return (_jsx(_Fragment, { children: withContainer ? (_jsx(Box, Object.assign({ my: 2, style: defaultProps }, { children: _jsxs(Box, Object.assign({ style: questionProps }, { children: [renderName && headerFirst && _jsx(QuestionName, Object.assign({}, nameProps)), _jsx(Box, Object.assign({ style: inputProps }, { children: inputElement }), `qinput|${question.QuestionSKU}`), renderName && !headerFirst && _jsx(QuestionName, Object.assign({}, nameProps))] })) }), question.QuestionSKU)) : (_jsxs(_Fragment, { children: [renderName && headerFirst && _jsx(QuestionName, Object.assign({}, nameProps)), inputElement, renderName && !headerFirst && _jsx(QuestionName, Object.assign({}, nameProps))] })) }));
};
